import React, {useEffect, useState} from "react";
import {Button, Col, DatePicker, Form, Input, notification, Row, Select, Space} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {applyFuelCampaignForm} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {useHistory} from "react-router-dom";
import {resourcePrefixType} from "../../util/Enums";
import {VirtualHost} from "../../constants";

const {Option} = Select;

function FuelCampaignForm(props) {
    let history = useHistory();
    const [form] = Form.useForm();
    const [taxAdministrationRequired, setTaxAdministrationRequired] = useState(false);
    let vehicleNumber = 1;

    useEffect(() => {
        setTaxAdministrationRequired(props && props.baseHeader && !props.baseHeader.toLocaleLowerCase("tr").includes("total"));
    }, []);

    function onFinish(values) {
        values.campaignId = props.campaignId;
        applyFuelCampaignForm(JSON.stringify(values)).then((response) => {
            notification.success({
                message: "Başarılı",
                description: "Başarılı bir şekilde kayıt oldunuz",
            })
            history.push("/Kampanyalar")
        }).catch((error) => {
            showAxiosError(error.response)
        })
    }

    function increase() {
        vehicleNumber += 1;
    }

    function decrease() {
        vehicleNumber -= 1;
    }

    return (
        <Form form={form} onFinish={onFinish} layout="vertical" wrapperCol={20}>
            <Row>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="TCKN"
                        name="tckn"
                        rules={[
                            {
                                min: 11,
                                max: 11,
                                required: true,
                                message: "Lütfen TCKN Numaranızı Giriniz.",
                            },
                        ]}
                    >
                        <Input name="tckn" size="large"/>
                    </Form.Item>
                </Col>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        label="Adınız Soyadınız"
                        name="nameSurname"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen Adınızı ve Soyadınızı Giriniz.",
                            },
                        ]}
                    >
                        <Input name="nameSurname" size="large"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="E-Posta Adresiniz"
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Lütfen E-Posta Adresinizi Giriniz.",
                            },
                        ]}
                    >
                        <Input name="email" size="large"/>
                    </Form.Item>
                </Col>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="Telefon Numaranız (GSM)"
                        name="phoneNumber"
                        rules={[
                            {
                                min: 10,
                                max: 10,
                                required: true,
                                message: "Lütfen Telefon Numaranızı Giriniz. (5XXXXXXXXX)",
                            },
                        ]}
                    >
                        <Input type="number" name="phoneNumber" size="large"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8} style={{
                    margin: '0 10px',
                }}>
                    <Form.Item
                        size="large"
                        label={(resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix ? "Eczane" : (resourcePrefixType.optikkart === VirtualHost.resourcePrefix ? "Optisyen" : "İşletme")) + " Adı"}
                        name="pharmacy"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen ${label}nızı giriniz."
                            },
                        ]}
                    >
                        <Input name="pharmacy" size="large"/>
                    </Form.Item>
                </Col>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="Vergi Dairesi"
                        name="taxAdministration"
                        rules={[
                            {
                                required: taxAdministrationRequired,
                                message: "Lütfen Vergi Dairenizi Giriniz."
                            },
                        ]}
                    >
                        <Input name="taxAdministration" size="large"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="İl"
                        name="city"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen İlinizi Giriniz."
                            },
                        ]}
                    >
                        <Input name="province" size="large"/>
                    </Form.Item>
                </Col>
                <Col span={8} style={{
                    margin: '0 8px',
                }}>
                    <Form.Item
                        size="large"
                        label="İlçe"
                        name="county"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen İlçenizi Giriniz."
                            },
                        ]}
                    >
                        <Input name="county" size="large"/>
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={16} style={{
                    margin: '0 9px',
                }}>
                    <Form.Item
                        size="large"
                        label="Adres"
                        name="address"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen Adresinizi Giriniz."
                            },
                        ]}
                    >
                        <Input name="address" size="large"/>
                    </Form.Item>
                </Col>
            </Row>
            <Form.List name="vehicle" initialValue={[
                {plate: "", fuelType: "", monthlyLimit: undefined}
            ]}>
                {(fields, {add, remove}) => (
                    <div>
                        {fields.map((field) => (
                            <Space key={field.key} align="baseline">
                                <Row>
                                    <Col span={7} style={{
                                        margin: '0 9px',
                                    }}>
                                        <Form.Item
                                            {...field}
                                            label={"Plaka"}
                                            name={[field.name, 'plate']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Lütfen Plakanızı Giriniz.',
                                                },
                                            ]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={5} style={{
                                        margin: '0 1px',
                                    }}>
                                        <Form.Item
                                            {...field}
                                            label="Yakıt Türü"
                                            name={[field.name, 'fuelType']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Lütfen Yakıt Türünü Giriniz.',
                                                },
                                            ]}
                                        >
                                            <Select
                                                defaultValue=""
                                                style={{
                                                    width: 120,
                                                }}
                                                allowClear
                                            >
                                                <Option value=""/>
                                                <Option value="GASOLINE">BENZİN</Option>
                                                <Option value="DIESEL">MOTORİN</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={7} style={{
                                        margin: '0 9px',
                                    }}>
                                        <Form.Item
                                            {...field}
                                            label="Aylık Limit"
                                            name={[field.name, 'monthlyLimit']}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Lütfen Aylık Limit Giriniz.',
                                                },
                                            ]}
                                        >
                                            <Input/>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <MinusCircleOutlined onClick={() => {
                                            remove(field.name)
                                            decrease()
                                        }}/>
                                    </Col>

                                </Row>

                            </Space>
                        ))}
                        <Row>
                            <Col span={17}>
                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => {
                                            add()
                                            increase()
                                        }}
                                        block
                                        icon={<PlusOutlined/>}
                                    >
                                        Araç Ekle
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </div>
                )}
            </Form.List>
            <Row>
                <Col span={17}>
                    <Form.Item>
                        <Button block type="primary" htmlType="submit">
                            Başvur
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )

}


export default FuelCampaignForm;


// WEBPACK FOOTER //
// ./src/component/CampaignForm/FuelCampaignForm.js